import { gql } from '@apollo/client'

const UPDATE_NONPROFIT_ORG_MISSION = gql`
  mutation updateNonprofitOrgMission($orgInfo: UpdateNonprofitOrgInput!) {
    updateNonprofitOrgMission(orgInfo: $orgInfo) {
      id
      missionStatement
    }
  }
`

export default UPDATE_NONPROFIT_ORG_MISSION
